export default "__VITE_ASSET__BOBR67Nm__"